/**
 * Formats a salary target string as US currency: $XXX,XXX.00
 * Handles various input formats: "200000", "$200,000", "200k", "1.5m", etc.
 * Returns the original string if it can't be parsed.
 */
/**
 * Formats salary input as the user types: strips non-digits, adds $ and commas.
 * e.g. "200000" → "$200,000"
 */
export function formatSalaryInput(value: string): string {
  const digits = value.replace(/\D/g, '')
  if (!digits) return ''
  const num = parseInt(digits, 10)
  if (isNaN(num)) return ''
  return '$' + num.toLocaleString('en-US')
}

export function formatSalary(value: string | number | undefined | null): string {
  if (value === undefined || value === null || value === '') return ''

  const str = String(value)
  const cleaned = str.replace(/[$,\s]/g, '').toLowerCase()

  let num: number
  if (cleaned.endsWith('k')) {
    num = parseFloat(cleaned.slice(0, -1)) * 1000
  } else if (cleaned.endsWith('m')) {
    num = parseFloat(cleaned.slice(0, -1)) * 1000000
  } else {
    num = parseFloat(cleaned)
  }

  if (isNaN(num)) return str

  return num.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
